import { VerticalBarChartComponent } from '../charts/vertical-bar-chart-component'

export class AFEmotionalComparison extends VerticalBarChartComponent {
 static config = {
  selector: 'afEmotionalComparison',
  controller: AFEmotionalComparison,
  bindings: VerticalBarChartComponent.config.bindings,
  template: VerticalBarChartComponent.config.template,
 }

 setProperties() {
  this.seriesColors = [
   '#0294EB',
   '#0294EB',
   '#0294EB',
   '#0294EB',
   '#0294EB',
   '#0294EB',
   '#0294EB',
   '#0294EB',
   '#0294EB',
  ]
  this.dataLabelFormatter = this.labelUtils.emotionalComparisonFormatter
 }
}
